<template lang="pug">
.portfolio__container.row-container
  .col.portfolio__col
    h1.projects__title.portfolio__title {{ title }}
    p.projects__subtitle.portfolio__subtitle {{ subtitle }}
    ContentParser(:content="contentAll")
    BaseFooter(:formValue="footer_data")
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { usePortfolioStore } from '~~/stores/portfolio'
// import { projectsContent } from '~/data/portfolio/projects'

const portfolioStore = usePortfolioStore()
await portfolioStore.setIndexPage()
const {title, subtitle, content, footer_data, meta, og} = storeToRefs(portfolioStore)

const contentAll = computed(() => [...content.value])
// const contentAll = computed(() => [...projectsContent, ...content.value])

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>

<style lang="scss">
.portfolio-container .project-promo__header {
  /*height: 240px;*/
  object-fit: cover;
  object-position: 50% 50%;
}

@media (min-width: $breakpoint-medium) {
  .portfolio-container .project-promo__header {
    /*height: auto;*/
  }
}
</style>

<style lang="scss" scoped>
.portfolio {

  &__container {
    // width: 100%;
    // margin-left: 0;

    @include notebook {
      // padding: 0 89px 0;
    }
  }

  &__col {
    padding-right: 15px;
    padding-left: 15px;
  }

  &__title,
  &__subtitle {
    color: $primary;
  }

  &__title {
    margin-bottom: 10px;
    font-size: 34px;

    @media (max-height: 899px) {
      margin-bottom: 0;
    }
  }

  &__subtitle {
    margin-bottom: 70px;
    max-width: 260px;

    @media (max-height: 899px) {
      margin-bottom: 40px;
    }
  }
}
</style>
